(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-3v1"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.pf-pdp--3v1').forEach((root) => {
    if (root.dataset.quantityReady === 'true') return;
    root.dataset.quantityReady = 'true';
    const quantity = root.querySelector('[data-pf-quantity]');
    root.querySelector('[data-pf-minus]')?.addEventListener('click', () => {
      if (!quantity) return;
      quantity.value = String(Math.max(1, Number(quantity.value || 1) - 1));
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
    });
    root.querySelector('[data-pf-plus]')?.addEventListener('click', () => {
      if (!quantity) return;
      quantity.value = String(Math.max(1, Number(quantity.value || 1) + 1));
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-ultra"] && !Shopify.designMode) return;
  try {
    
function initUltraControls(scope){
  scope.querySelectorAll('.pf-pdp--ultra').forEach(root=>{
    if(root.dataset.controlsReady)return;
    root.dataset.controlsReady='true';
    const input=root.querySelector('[data-ultra-quantity]');
    const minus=root.querySelector('[data-ultra-minus]');
    const plus=root.querySelector('[data-ultra-plus]');
    if(!input||!minus||!plus)return;
    input.addEventListener('change',()=>{
      const value=Math.max(1,Math.trunc(Number(input.value)||1));
      input.value=String(value);
      const sticky=root.querySelector('.pf-pdp__sticky input[name=quantity]');
      if(sticky)sticky.value=String(value);
    });
    const update=delta=>{
      const current=parseInt(input.value,10);
      input.value=String(Math.max(1,(Number.isFinite(current)?current:1)+delta));
      input.dispatchEvent(new Event('change',{bubbles:true}));
    };
    minus.addEventListener('click',()=>update(-1));
    plus.addEventListener('click',()=>update(1));
  });
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',()=>initUltraControls(document),{once:true});}else{initUltraControls(document);}
document.addEventListener('shopify:section:load',event=>initUltraControls(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-activity-story"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initStoryVideos(scope){
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var figs=(scope||document).querySelectorAll('[data-pf-story-video]');
    Array.prototype.forEach.call(figs,function(fig){
      if(fig.getAttribute('data-ready'))return;
      fig.setAttribute('data-ready','1');
      var v=fig.querySelector('video');
      var btn=fig.querySelector('[data-pf-story-play]');
      if(!v)return;
      v.muted=true;
      if(reduce){
        v.removeAttribute('autoplay');
        v.autoplay=false;
        v.pause();
        v.load();
        fig.classList.add('is-paused');
      }
      if(btn){
        btn.addEventListener('click',function(){
          var p=v.play();
          if(p&&p.catch)p.catch(function(){});
          fig.classList.remove('is-paused');
        });
      }
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){initStoryVideos(document);});}
  else{initStoryVideos(document);}
  document.addEventListener('shopify:section:load',function(e){initStoryVideos(e.target);});
  document.addEventListener('shopify:block:select',function(e){initStoryVideos(e.target.parentNode||document);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-fidelity-footer"]) return;
  try {
    
function initPrefireFooterLocalization(scope=document){
  scope.querySelectorAll('[data-pf-localization]').forEach(form=>{
    if(form.dataset.pfLocalizationReady==='true')return;
    form.dataset.pfLocalizationReady='true';
    const select=form.querySelector('select[name="country_code"]');
    if(!select)return;
    const face=form.querySelector('[data-pf-country-text]');
    select.addEventListener('change',()=>{
      if(face&&select.selectedOptions[0])face.textContent=select.selectedOptions[0].textContent;
      if(typeof form.requestSubmit==='function')form.requestSubmit();
      else form.submit();
    });
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initPrefireFooterLocalization(document),{once:true});
else initPrefireFooterLocalization(document);
document.addEventListener('shopify:section:load',event=>initPrefireFooterLocalization(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-fidelity-header"]) return;
  try {
    
function syncPrefireHeaderCart(count){
  document.querySelectorAll('[data-pf-header-cart-count]').forEach(el=>{el.textContent=String(count);});
  document.querySelectorAll('.pf-fidelity-header__cart').forEach(link=>{
    link.setAttribute('aria-label','Cart, '+count+' '+(count===1?'item':'items'));
    let badge=link.querySelector('.pf-fidelity-header__count');
    if(count>0){
      if(!badge){badge=document.createElement('span');badge.className='pf-fidelity-header__count';link.appendChild(badge);}
      badge.textContent=String(count);
    }else if(badge){badge.remove();}
  });
}
function guardPrefireCartGlyph(){
  const link=document.getElementById('cart-icon-bubble');
  if(!link||link.dataset.pfGlyphGuard==='true'||!link.classList.contains('pf-fidelity-header__cart'))return;
  link.dataset.pfGlyphGuard='true';
  const glyph=link.querySelector('.pf-glyph--cart');
  const text=link.querySelector('.pf-fidelity-header__cart-text');
  if(!glyph)return;
  const keep=glyph.outerHTML+(text?text.outerHTML:'');
  new MutationObserver(()=>{
    if(link.querySelector('.pf-glyph--cart'))return;
    const count=parseInt((link.querySelector('.pf-fidelity-header__count')||{}).textContent||'0',10)||0;
    link.innerHTML=keep;
    syncPrefireHeaderCart(count);
  }).observe(link,{childList:true});
}
function refreshPrefireHeaderCart(){
  const root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  fetch(root+'cart.js',{headers:{Accept:'application/json'}}).then(r=>r.ok?r.json():null).then(cart=>{if(cart)syncPrefireHeaderCart(cart.item_count||0);}).catch(()=>{});
}
function initPrefireNav(scope=document){
  scope.querySelectorAll('[data-pf-header]').forEach(header=>{
    if(header.dataset.navReady==='true')return;
    header.dataset.navReady='true';
    const toggle=header.querySelector('[data-pf-nav-toggle]');
    const panel=header.querySelector('[data-pf-mobile-nav]');
    if(!toggle||!panel)return;
    const setOpen=open=>{
      header.toggleAttribute('data-nav-open',open);
      toggle.setAttribute('aria-expanded',open?'true':'false');
      toggle.setAttribute('aria-label',open?'Close navigation':'Open navigation');
      panel.setAttribute('aria-hidden',open?'false':'true');
      document.documentElement.classList.toggle('pf-nav-locked',open);
      if(open) panel.querySelector('a')?.focus({preventScroll:true});
    };
    toggle.addEventListener('click',()=>setOpen(toggle.getAttribute('aria-expanded')!=='true'));
    panel.querySelectorAll('a').forEach(link=>link.addEventListener('click',()=>setOpen(false)));
    document.addEventListener('keydown',event=>{
      if(event.key==='Escape'&&toggle.getAttribute('aria-expanded')==='true'){
        setOpen(false);
        toggle.focus();
      }
    });
    header.querySelectorAll('.pf-nav-desktop-group').forEach(group=>{
      group.addEventListener('toggle',()=>{
        if(!group.open)return;
        header.querySelectorAll('.pf-nav-desktop-group').forEach(other=>{if(other!==group)other.removeAttribute('open');});
      });
    });
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>{initPrefireNav(document);guardPrefireCartGlyph();},{once:true});
else{initPrefireNav(document);guardPrefireCartGlyph();}
document.addEventListener('shopify:section:load',event=>initPrefireNav(event.target));
if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',()=>{
    refreshPrefireHeaderCart();
    if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'){
      subscribe(PUB_SUB_EVENTS.cartUpdate,event=>syncPrefireHeaderCart(event?.cartData?.item_count||0));
    }
  },{once:true});
}else{
  refreshPrefireHeaderCart();
  if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'){
    subscribe(PUB_SUB_EVENTS.cartUpdate,event=>syncPrefireHeaderCart(event?.cartData?.item_count||0));
  }
}
window.addEventListener('pageshow',refreshPrefireHeaderCart);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-field-notes"] && !Shopify.designMode) return;
  try {
    
/* OCT 5 (home): lazy-start field-note videos. The MP4 URL is only attached when a card is near the screen,
   it plays while at least 35% visible and pauses off screen. Reduced motion keeps the poster only. */
function initFieldNoteVideos(scope){
  const videos=Array.from(scope.querySelectorAll('.pf-field-notes [data-pf-lazy-video]'));
  if(!videos.length)return;
  const reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const attach=video=>{
    if(video.dataset.pfReady)return;
    video.dataset.pfReady='1';
    video.querySelectorAll('source[data-src]').forEach(s=>{s.src=s.dataset.src;s.removeAttribute('data-src');});
    video.load();
  };
  videos.forEach(video=>{
    video.muted=true;
    video.playsInline=true;
    const media=video.closest('[data-pf-field-media]');
    video.addEventListener('playing',()=>media&&media.classList.add('is-playing'));
    if(reduceMotion){video.removeAttribute('autoplay');return;}
    if(!('IntersectionObserver' in window)){attach(video);video.play().catch(()=>{});return;}
    const near=new IntersectionObserver(entries=>{
      entries.forEach(entry=>{if(entry.isIntersecting){attach(entry.target);near.unobserve(entry.target);}});
    },{rootMargin:'0px 0px 300px 0px'});
    const view=new IntersectionObserver(entries=>{
      entries.forEach(entry=>{
        const v=entry.target;
        if(entry.isIntersecting&&entry.intersectionRatio>=0.35){attach(v);v.play().catch(()=>{});}
        else if(v.dataset.pfReady){v.pause();}
      });
    },{threshold:[0,0.35]});
    near.observe(video);
    view.observe(video);
  });
}
if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',()=>initFieldNoteVideos(document),{once:true});
}else{
  initFieldNoteVideos(document);
}
document.addEventListener('shopify:section:load',event=>initFieldNoteVideos(event.target));

  } catch(e) { console.error(e); }
})();
})();
